import { render, staticRenderFns } from "./RemovedDepartments.vue?vue&type=template&id=5197b88d&"
import script from "./RemovedDepartments.vue?vue&type=script&lang=js&"
export * from "./RemovedDepartments.vue?vue&type=script&lang=js&"
import style0 from "./RemovedDepartments.vue?vue&type=style&index=0&id=5197b88d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports